"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var Button_1 = __importDefault(require("../Button"));
var styles_1 = require("./styles");
var material_1 = require("@mui/material");
var MenuItemAll_1 = __importDefault(require("./MenuItemAll"));
var CategoricMenu = function (_a) {
    var ariaLabel = _a["aria-label"], _b = _a.anchorOrigin, anchorOrigin = _b === void 0 ? { vertical: 'bottom', horizontal: 'left' } : _b, buttonText = _a.buttonText, _c = _a.buttonVariant, buttonVariant = _c === void 0 ? 'contained' : _c, buttonSx = _a.buttonSx, dataTestId = _a["data-testid"], handleNavigationClick = _a.handleNavigationClick, options = _a.options, sort = _a.sort, sortOrder = _a.sortOrder, style = _a.style, sx = _a.sx, _d = _a.transformOrigin, transformOrigin = _d === void 0 ? { vertical: 'top', horizontal: 'left' } : _d;
    var _e = __read((0, react_1.useState)(null), 2), anchorEl = _e[0], setAnchorEl = _e[1];
    var grouped = lodash_1.default.mapValues(lodash_1.default.groupBy(options, 'category'), function (glist) {
        return glist.map(function (item) { return lodash_1.default.omit(item, 'category'); });
    });
    var order = Object.keys(grouped);
    if (sort && !sortOrder) {
        order.sort();
    }
    var groupedArray = Object.entries(grouped).map(function (item) {
        var _a;
        return (_a = {},
            _a[item[0]] = item[1],
            _a);
    });
    var groupedSortedArray = lodash_1.default.sortBy(groupedArray, sortOrder ? sortOrder : order);
    var menuItems = null;
    (0, react_1.useEffect)(function () {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                var _a;
                if (mutation.addedNodes.length) {
                    menuItems = document.querySelectorAll('[role="menuitem"]');
                    (_a = menuItems[0]) === null || _a === void 0 ? void 0 : _a.focus();
                }
            });
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
        return function () {
            observer.disconnect();
        };
    }, [Boolean(anchorEl)]);
    var currentIndex = 0;
    var handleKeyboardNavigation = function (e) {
        if (anchorEl && menuItems && menuItems.length > 0) {
            var newFocus = null;
            switch (e.key) {
                case 'ArrowUp':
                    if (currentIndex === 0) {
                        currentIndex = menuItems.length;
                    }
                    currentIndex--;
                    newFocus = menuItems[currentIndex];
                    break;
                case 'ArrowDown':
                    if (currentIndex === menuItems.length - 1) {
                        currentIndex = -1;
                    }
                    currentIndex++;
                    newFocus = menuItems[currentIndex];
                    break;
            }
            if (newFocus) {
                newFocus.focus();
            }
        }
    };
    return (react_1.default.createElement("div", { "data-testid": dataTestId },
        react_1.default.createElement(Button_1.default, { "aria-expanded": !!anchorEl, "aria-haspopup": "true", "aria-label": ariaLabel, "data-testid": "".concat(dataTestId, "-button"), disableFocusRipple: true, disableRipple: true, onClick: function (e) { return setAnchorEl(e.currentTarget); }, sx: buttonSx, variant: buttonVariant },
            react_1.default.createElement(styles_1.ButtonText, null, buttonText)),
        react_1.default.createElement(material_1.Menu, { "aria-label": ariaLabel, anchorEl: anchorEl, anchorOrigin: anchorOrigin, onKeyDown: handleKeyboardNavigation, onClose: function () {
                setAnchorEl(null);
            }, open: Boolean(anchorEl), slotProps: {
                paper: {
                    sx: sx,
                    style: style,
                },
            }, "data-testid": "".concat(dataTestId, "-menu"), transformOrigin: transformOrigin }, groupedSortedArray.map(function (value, index) { return (react_1.default.createElement("li", { role: "group", "aria-labelledby": "".concat(Object.keys(value)[0]), key: Object.keys(value)[0] },
            react_1.default.createElement(styles_1.GroupHeader, { role: "presentation", id: "".concat(Object.keys(value)[0]) },
                react_1.default.createElement(styles_1.GroupHeaderText, null, Object.keys(value)[0])),
            react_1.default.createElement(styles_1.GroupItems, { "aria-label": "".concat(Object.keys(value)[0]), key: "".concat(Object.keys(value)[0], "-groupitems"), role: "menu" }, Object.values(value)[0].map(function (item) { return (react_1.default.createElement(MenuItemAll_1.default, { "aria-label": ariaLabel, "data-testid": "".concat(dataTestId, "-").concat(item.primary), menuItem: item, handleNavigation: handleNavigationClick, key: "".concat(item.primary, " ").concat(item.secondary) })); })),
            index !== groupedSortedArray.length - 1 && (react_1.default.createElement(styles_1.FullWidthDivider, { role: "separator", "aria-hidden": true })))); }))));
};
exports.default = CategoricMenu;
//# sourceMappingURL=index.js.map